import React, { FC } from 'react'
import { StyledCart } from '.'
import CartItem from './CartItem'
import { CartItemType, CartItemsType } from '../../types'

type Props = {
  items: CartItemType[];
  total?: number;
  discount?: number;
  isReceipt?: boolean;
  removeFromCart?(id: string, type: CartItemsType): void;
}

const Cart: FC<Props> = ({
  items, total, discount, isReceipt, removeFromCart
}) => {
  return (
    <StyledCart className="cart">
      <ul className="cart-items">
        {items.map((item, index) => {
          return (
            <CartItem
              item={item}
              isReceipt={isReceipt}
              removeFromCart={removeFromCart}
              key={index}
            />
          )
        })}
      </ul>
      {total && (
        <div className="cart-total">
          {!!discount && (
            <div className="discount-info">
              <span>
                <s>${(total + discount).toFixed(2)}</s>
              </span>
              <span>-${discount.toFixed(2)}</span>
            </div>
          )}
          <span>
            Total <b>${total.toFixed(2)}</b>
          </span>
        </div>
      )}
    </StyledCart>
  )
}

export default Cart
